// extracted by mini-css-extract-plugin
export default {"deleteImageButton":"SelectImage_deleteImageButton__0jhSZ"};